import { render, staticRenderFns } from "./CouponAdd.vue?vue&type=template&id=68ce41a1&"
import script from "./CouponAdd.vue?vue&type=script&lang=js&"
export * from "./CouponAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports